import React, { memo } from "react";
import { CustomCardHeader } from "@components/Common/CustomCardStyled";
import { CrossIcon } from "@aureskonnect/react-ui";
import { canceledHandleButton } from "../../hooks";

export const HeaderSection = memo(({ title,
    isEdited,
    setIsEdited,
    setDataChoice,
    setIsAddChoiceClicked,
    isAddChoiceClicked,
    setIsConsult,
    isActionsClicked, }: any) => (
    <CustomCardHeader className="d-flex align-items-center justify-content-between">
        <h5 className="pt-3 mdr_txt_FRtitleFormPaymentMethod">{title}</h5>
        <CrossIcon
            className="mdr_icn_FRcloseForm"
            style={{ cursor: "pointer" }}
            height={13}
            width={13}
            onClick={() => canceledHandleButton(
                isEdited,
                setIsEdited,
                setDataChoice,
                setIsAddChoiceClicked,
                isAddChoiceClicked,
                setIsConsult,
                isActionsClicked
            )}
        />
    </CustomCardHeader>
));
